import Vue from 'vue'
import VueFlatPicker from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

Vue.use(VueFlatPicker)
